import { useAtomValue } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useTenantUsers from "../tenantUsers/useTenantUsers";
import useUser from "../auth/useUser";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import WorkspaceAPI from "../../api/WorkspaceAPI";
import { handleWorkspacesUserUpdate } from "../../../utils/WorkspaceUtils";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

const useJoinWorkspace = () => {
  const queryClient = useQueryClient();
  const { wPermissions: workspacePermissions } = useUser();
  const tenantID = useAtomValue(tenantIDAtom);
  const { users } = useTenantUsers();

  const joinWorkspace = useMutation({
    mutationFn: ({
      workspaceID,
      onSuccess,
    }: {
      workspaceID: string;
      onSuccess?: () => void;
      onSettled?: () => void;
    }) => {
      return WorkspaceAPI.joinWorkspace(workspaceID).then((data) => {
        handleWorkspacesUserUpdate(
          data,
          queryClient,
          workspaceID,
          workspacePermissions,
          users,
          tenantID
        );

        callFunctionIfExists(onSuccess);
      });
    },

    onSettled: (_, __, { onSettled }) => {
      callFunctionIfExists(onSettled);
    },
  });

  return {
    joinWorkspace: joinWorkspace.mutate,
    joiningWorkspace: joinWorkspace.isPending,
    joinWorkspaceError: joinWorkspace.error
      ? getErrorMessage(joinWorkspace.error)
      : null,
  };
};

export default useJoinWorkspace;
